<template>
  <transition>
    <div 
      class="confirm"
    >
      <div class="confirm_block">
        {{ title }}
        <div class="confirm_buttons">
          <div 
            v-for="button in buttons"
            :key="button.key"
            @click="click(button.key)"
            class="button"
          >
            {{ button.text  }}
          </div>
        </div>
      </div>
    </div>
  </transition>  
</template>
<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    title: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      buttons: [
        {
          key: 'yes',
          text: 'Да'
        },
        {
          key: 'not',
          text: 'Нет'
        }
      ]
    }
  },

  methods: {
    click(key) {
      let clicked = true

      if (key == 'not') {
        clicked = false
      }

      this.$emit('click', clicked)
    }
  }
}
</script>
<style lang="scss" scoped>
  .confirm {
    left: 0;
    top: 0;
    position: fixed;
    background-color: rgb(63,63,63, 0.3);
    width: 100%;
    height: 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    &_block {
      font-size: 20px;
      font-weight: 600;
      background-color: #fff;
      padding: 20px 20px 20px 20px;
    }

    &_buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;

      .button {
        padding: 5px 40px;
        background-color: #004581;
        color: #fff;
        cursor: pointer;
      }
    }
    
  }
</style>